import { useState, useEffect } from 'react';
import { Loader2, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { useTranslation } from 'react-i18next'; // Assuming we have i18n available, or will hardcode dynamic

const LinkExpired = ({ reason }) => {
  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <Card className="bg-zinc-900 border-zinc-800 max-w-md w-full">
        <CardContent className="p-8 text-center">
          <AlertCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-white mb-2">Lien Expiré</h1>
          <p className="text-zinc-400 mb-6">
            {reason || "Ce lien d'entretien n'est plus valide."}
          </p>
          <p className="text-sm text-zinc-500">
            Si vous pensez qu'il s'agit d'une erreur, veuillez contacter le recruteur.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default LinkExpired;
